// Wrapper extra padding init
export default function initWrapperExtraPadding() {
	var $wrapper = jQuery('#wrapper');
	var $header = jQuery('#header');
	var noPadding = jQuery('.header-fixed-mobile').length;

	if (!noPadding && $wrapper.length && $wrapper.length) {
		jQuery(window).on('load resize orientationchange refreshWrapperExtraPadding', function () {
			$wrapper.css('padding-top', $header.outerHeight());
		}).trigger('refreshWrapperExtraPadding');
	}
}
